import { EndScreenCase } from "@/components/endScreens";
import { NewIntakeLayout } from "@/layout";
import { PATIENT_STATUS } from "@/utils";

export const EndScreenDisqualified = () => {
  return (
    <NewIntakeLayout isEndScreen>
      <EndScreenCase
        status={PATIENT_STATUS.DISQUALIFIED}
        title={"No providers found"}
        description={`We could’t find any DME providers for the patient’s insurance in their state.`}
      />
    </NewIntakeLayout>
  );
};
